import * as actionTypes from '../actions/actionTypes';

const initialState = {
  orders: [],
  loading: false,
  purchased: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PURCHASE_INIT:
      return {
        ...state,
        purchased: false
      };
    case actionTypes.PURCHASE_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.PURCHASE_SUCCESS:
      const newOrder = {
        ...action.payload.orderData,
        id: action.payload.orderID
      };
      return {
        ...state,
        loading: false,
        purchased: true,
        orders: state.orders.concat(newOrder)
      };
    case actionTypes.PURCHASE_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.FETCH_ORDERS__START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.FETCH_ORDERS__SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.orders
      };
    case actionTypes.FETCH_ORDERS__FAIL:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default reducer;